export const PORTAL_CUSTOMER_CONTACTING_CLICK = 'portal-customer-contacting-click';
export const PORTAL_CUSTOMER_VITA_LOAD = 'portal-customer-vita-load';
